import React from 'react';
import logoImage from '../logo-docweb.png';

function DocWebLogo() {
  return (
    <img 
      src={logoImage}
      alt="DocWeb Logo" 
      style={{ width: '100%', height: 'auto', display: 'block' }}
    />
  );
}

export default DocWebLogo;